import React, { useState } from 'react'
import {
  AppBar,
  Box,
  Toolbar,
  IconButton,
  Typography,
  Menu,
  MenuItem,
  Container,
  Link,
  InputBase,
  Tooltip,
  Stack,
  List,
  ListItem,
  Divider,
  Grid,
  SwipeableDrawer,
} from '@mui/material'
import { useHistory, useLocation } from 'react-router-dom'
import { styled, alpha } from '@mui/material/styles'
import AccountCircle from '@mui/icons-material/AccountCircle'
import SettingsIcon from '@mui/icons-material/Settings'
import LogoutIcon from '@mui/icons-material/Logout'
import SearchIcon from '@mui/icons-material/Search'
import MenuIcon from '@mui/icons-material/Menu'
import mainLogo from '../Asset/images/mcash-logo.png'
import CloseIcon from '@mui/icons-material/Close'
import Logo from '../Asset/images/logo.png'

const Search = styled('div')(({ theme }) => ({
  position: 'relative',
  borderRadius: '30px',
  backgroundColor: alpha(theme.palette.common.black, 0.15),
  '&:hover': {
    backgroundColor: alpha(theme.palette.common.black, 0.25),
  },
  marginLeft: 0,
  width: '100%',
  marginRight: '10px',
  [theme.breakpoints.up('sm')]: {
    marginLeft: theme.spacing(1),
    width: 'auto',
  },
}))

const SearchIconWrapper = styled('div')(({ theme }) => ({
  padding: theme.spacing(0, 2),
  height: '100%',
  position: 'absolute',
  pointerEvents: 'none',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
}))

const StyledInputBase = styled(InputBase)(({ theme }) => ({
  color: 'inherit',
  '& .MuiInputBase-input': {
    padding: theme.spacing(1, 1, 1, 0),
    // vertical padding + font size from searchIcon
    paddingLeft: `calc(1em + ${theme.spacing(4)})`,
    transition: theme.transitions.create('width'),
    width: '100%',
    [theme.breakpoints.up('sm')]: {
      width: '12ch',
      '&:focus': {
        width: '20ch',
      },
    },
  },
}))

const Header = () => {
  const auth = JSON.parse(localStorage.getItem('access_token'))
  const [anchorElNav, setAnchorElNav] = useState(null)
  const [anchorElUser, setAnchorElUser] = useState(null)
  const history = useHistory()

  const location = useLocation()

  //destructuring pathname from location
  const { pathname } = location

  //Javascript split method to get the name of the path in array
  const splitLocation = pathname.split('/')

  const handleOpenUserMenu = (event) => {
    setAnchorElUser(event.currentTarget)
  }

  const handleCloseNavMenu = () => {
    setAnchorElNav(null)
  }

  const handleCloseUserMenu = () => {
    setAnchorElUser(null)
  }

  const logOutClick = () => {
    localStorage.removeItem('access_token')
    history.push('/')
  }

  const searchEvent = (e) => {
    if (e.key === 'Enter') {
      history.push(`/products/?search=${e.target.value}`)
    }
  }

  const list = (anchor) => (
    <Box
      sx={{ width: anchor === 'top' || anchor === 'bottom' ? 'auto' : 250 }}
      role='presentation'
      onClick={toggleDrawer(anchor, false)}
      onKeyDown={toggleDrawer(anchor, false)}
    >
      <List>
        <ListItem sx={{ justifyContent: 'space-between', pb: '30px' }}>
          <Typography
            variant='h6'
            noWrap
            component='div'
            sx={{
              mr: 2,
              mt: 2,
              display: { xs: 'flex', md: 'none' },
            }}
          >
            <Link href='/'>
              <img
                src={Logo}
                alt='Logo Face'
                style={{
                  width: '40px',
                  align: 'left',
                }}
                sx={{}}
              />{' '}
            </Link>
          </Typography>
          <CloseIcon fontSize='large' onClick={toggleDrawer('top', false)} />
        </ListItem>
        <ListItem button>
          <Link href='/' underline='none' sx={{ color: '#000' }}>
            <Typography
              sx={{
                fontSize: '15px',
                lineHeight: '20px',
              }}
            >
              Featured
            </Typography>
          </Link>
        </ListItem>
        <ListItem button>
          <Link href='/top-chart' underline='none' sx={{ color: '#000' }}>
            <Typography
              sx={{
                fontSize: '15px',
                lineHeight: '20px',
              }}
            >
              Top Chart
            </Typography>
          </Link>
        </ListItem>
        <ListItem button>
          <Link href='/categories' underline='none' sx={{ color: '#000' }}>
            <Typography
              sx={{
                fontSize: '15px',
                lineHeight: '20px',
              }}
            >
              Categories
            </Typography>
          </Link>
        </ListItem>
      </List>
      <Divider />
    </Box>
  )

  const [state, setState] = useState({
    top: false,
    left: false,
    bottom: false,
    right: false,
  })

  const toggleDrawer = (anchor, open) => (event) => {
    if (
      event.type === 'keydown' &&
      (event.key === 'Tab' || event.key === 'Shift')
    ) {
      return
    }

    setState({ ...state, [anchor]: open })
  }

  return (
    <AppBar
      position='static'
      sx={{ background: 'transparent', boxShadow: 'none' }}
    >
      <Container maxWidth='xl'>
        <Toolbar disableGutters>
          <Link href='/'>
            <Typography
              variant='h6'
              noWrap
              component='div'
              sx={{ mr: 2, display: { xs: 'none', md: 'flex' } }}
            >
              <img src={mainLogo} alt='Mcash Logo' width='175px' />
            </Typography>
          </Link>
          <Box sx={{ flexGrow: 1, display: { xs: 'flex', md: 'none' } }}>
            <IconButton
              size='large'
              aria-label='account of current user'
              aria-controls='menu-appbar'
              aria-haspopup='true'
              onClick={toggleDrawer('top', true)}
              color='inherit'
            >
              <MenuIcon sx={{ color: '#000' }} />
            </IconButton>
            <Menu
              id='menu-appbar'
              anchorEl={anchorElNav}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'left',
              }}
              keepMounted
              transformOrigin={{
                vertical: 'top',
                horizontal: 'left',
              }}
              open={Boolean(anchorElNav)}
              onClose={handleCloseNavMenu}
              sx={{
                display: { xs: 'block', md: 'none' },
              }}
            >
              <MenuItem>
                <Link href='/' underline='none'>
                  <Typography sx={{ pl: '20px', color: '#000', fontSize: 14 }}>
                    Featured
                  </Typography>
                </Link>
              </MenuItem>
              <MenuItem>
                <Link href='/top-chart' underline='none'>
                  <Typography sx={{ pl: '20px', color: '#000', fontSize: 14 }}>
                    Top Chart
                  </Typography>
                </Link>
              </MenuItem>
              <MenuItem>
                <Link href='/categories' underline='none'>
                  <Typography sx={{ pl: '20px', color: '#000', fontSize: 14 }}>
                    Categories
                  </Typography>
                </Link>
              </MenuItem>
            </Menu>
          </Box>
          <Link
            href='/'
            sx={{ flexGrow: 1, display: { xs: 'flex', md: 'none' } }}
          >
            <Typography variant='h6' noWrap component='div'>
              <img src={mainLogo} alt='Mcash Logo' width='175px' />
            </Typography>
          </Link>
          <Box
            sx={{
              flexGrow: 1,
              display: { xs: 'none', md: 'flex' },
            }}
          />
          <Box
            sx={{
              flexGrow: 1,
              display: {
                xs: 'none',
                md: 'flex',
              },
            }}
          >
            <Link href='/' underline='none'>
              <Typography
                sx={{
                  pl: '20px',
                  color: splitLocation[1] === '' ? 'red' : '#000',
                  fontSize: 12,
                }}
              >
                Featured
              </Typography>
            </Link>
            <Link href='/top-chart' underline='none'>
              <Typography
                sx={{
                  pl: '20px',
                  color: splitLocation[1] === 'top-chart' ? 'red' : '#000',
                  fontSize: 12,
                }}
              >
                Top Chart
              </Typography>
            </Link>
            <Link href='/categories' underline='none'>
              <Typography
                sx={{
                  pl: '20px',
                  color: splitLocation[1] === 'categories' ? 'red' : '#000',
                  fontSize: 12,
                }}
              >
                Categories
              </Typography>
            </Link>
          </Box>
          <Box
            sx={{
              flexGrow: 0,
              display: { xs: 'none', md: 'flex' },
            }}
          >
            <Search>
              <SearchIconWrapper>
                <SearchIcon />
              </SearchIconWrapper>
              <StyledInputBase
                placeholder='Search Apps'
                inputProps={{ 'aria-label': 'search' }}
                onKeyPress={searchEvent}
              />
            </Search>
          </Box>
          <Box sx={{ flexGrow: 0 }}>
            {auth ? (
              <>
                <Tooltip title='Open settings'>
                  <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}>
                    <AccountCircle fontSize='large' />
                  </IconButton>
                </Tooltip>
                <Menu
                  sx={{ mt: '45px' }}
                  id='menu-appbar'
                  anchorEl={anchorElUser}
                  anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                  }}
                  keepMounted
                  transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                  }}
                  open={Boolean(anchorElUser)}
                  onClose={handleCloseUserMenu}
                >
                  <MenuItem onClick={handleCloseUserMenu}>
                    <Link
                      href='/account'
                      underline='none'
                      sx={{ color: '#000' }}
                    >
                      <Stack direction='row' spacing={2}>
                        <SettingsIcon />
                        <Typography textAlign='center'>My Account</Typography>
                      </Stack>
                    </Link>
                  </MenuItem>
                  <MenuItem onClick={handleCloseUserMenu}>
                    <Stack direction='row' spacing={2}>
                      <LogoutIcon />
                      <Typography textAlign='center' onClick={logOutClick}>
                        Logout
                      </Typography>
                    </Stack>
                  </MenuItem>
                </Menu>
              </>
            ) : (
              <>
                <Link href={'/login'} underline='none'>
                  <IconButton sx={{ p: 0 }}>
                    <AccountCircle fontSize='large' />
                  </IconButton>
                </Link>
              </>
            )}
          </Box>
        </Toolbar>
        <Grid item xs={12} sx={{ color: '#000' }}>
          {['left', 'right', 'top', 'bottom'].map((anchor) => (
            <React.Fragment key={anchor}>
              {/* <Button onClick={toggleDrawer(anchor, true)}>{anchor}</Button> */}
              <SwipeableDrawer
                anchor={anchor}
                open={state[anchor]}
                onClose={toggleDrawer(anchor, false)}
                onOpen={toggleDrawer(anchor, true)}
              >
                {list(anchor)}
              </SwipeableDrawer>
            </React.Fragment>
          ))}
        </Grid>
      </Container>
    </AppBar>
  )
}
export default Header
